import type { Workflow, WorkflowEvent } from "@llamaindex/workflow-core";
import { AsyncContext } from "@llamaindex/workflow-core/async-context";
import type { RequestHandlerExtra } from "@modelcontextprotocol/sdk/shared/protocol.js";
import type { CallToolResult } from "@modelcontextprotocol/sdk/types.js";
import { runWorkflow } from "./stream/run";

const requestHandlerExtraAsyncLocalStorage = new AsyncContext.Variable<
  RequestHandlerExtra<any, any>
>();

export const getReqHandlerExtra = () => {
  const extra = requestHandlerExtraAsyncLocalStorage.get();
  if (!extra) {
    throw new Error("Request handler extra not set");
  }
  return extra;
};

export function mcpTool<
  Start extends { [x: string]: any },
  Stop extends CallToolResult,
>(
  workflow: Workflow,
  start: WorkflowEvent<Start>,
  stop: WorkflowEvent<Stop>,
): (
  args: Start,
  extra: RequestHandlerExtra<any, any>,
) => CallToolResult | Promise<CallToolResult> {
  return async (args, extra) =>
    requestHandlerExtraAsyncLocalStorage.run(extra, async () => {
      const { data } = await runWorkflow(workflow, start.with(args), stop);
      return data;
    });
}
